import React from 'react'
import { View, Text } from "@react-pdf/renderer";
import { insertPDFNewlines, logger } from '../../../../../utils';

const TableRow = ({ item }) => {

    return (
        <View
            style={{
                flexDirection: "row",
                padding: "0px 10px"
            }}
        >

            <View
                style={{
                    width: "100%",
                    flexDirection: "row"
                }}
            >
                {/* Component */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "35%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        borderRightWidth: "0px",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center"
                        }}
                    >
                        {item.component ? item.component : "-"}
                    </Text>
                </View>
                {/* Component */}

                {/* QTY */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "5%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        borderRightWidth: "0px",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center"
                        }}
                    >
                        {item.quantity ? item.quantity : "-"}
                    </Text>
                </View>
                {/* QTY */}

                {/* Evaluation */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "15%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        borderRightWidth: "0px",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center"
                        }}
                    >
                        {item.evaluation ? item.evaluation : "-"}
                    </Text>
                </View>
                {/* Evaluation */}

                {/* Class */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "15%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        borderRightWidth: "0px",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center"
                        }}
                    >
                        {item.classification ? item.classification : "-"}
                    </Text>
                </View>
                {/* Class */}

                {/* Pic */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "25%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        borderRightWidth: "0px",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center"
                        }}
                    >
                        -
                    </Text>
                </View>
                {/* Pic */}

                {/* Note */}
                <View
                    style={{
                        backgroundColor: "#fff",
                        padding: "1px",
                        width: "5%",
                        borderWidth: "1px",
                        borderTopWidth: "0",
                        borderColor: "#000",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                >
                    <Text
                        style={{
                            fontSize: "7px",
                            color: "#000",
                            textAlign: "center",
                            flexWrap: "wrap",
                            textOverflow: "ellipsis"
                        }}
                    >
                        -
                        {/* {insertPDFNewlines("Hello world this is me some_pic_123331.jpg", 10)} */}
                    </Text>
                </View>
                {/* Note */}
            </View>
        </View>
    )
}

export default TableRow